module.exports = __webpack_public_path__ + "img/gett.64ac1b21.svg";